import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import BaseButton from "src/components/BaseButton";
import { useUpdateAvailable } from "src/update/useUpdateAvailable";

/**
 * 새 버전 안내 문구
 */
const TEXT = {
  available: "새 버전이 배포되었습니다. 새로고침하면 최신 화면으로 업데이트됩니다.",
  reload: "새로고침",
  collapse: "접기",
  expand: "새 버전 안내 펼치기",
  badge: "새 버전이 있습니다.",
};

/** 배너용 폴링 주기(10분) - 마운트,탭 재활성 트리거의 보강 */
const POLL_INTERVAL_MS = 10 * 60 * 1000;

/**
 * 지속형 업데이트 배너
 * - 새 버전 감지 시 노출되어 사용자가 새로고침할 때까지 유지
 */
function UpdateBanner() {
  const available = useUpdateAvailable({ pollIntervalMs: POLL_INTERVAL_MS });
  const { pathname } = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    setCollapsed(false);
  }, [pathname]);

  if (!available) return null;

  if (collapsed) {
    return (
      <button type="button" className="update-chip" aria-label={TEXT.expand} onClick={() => setCollapsed(false)}>
        <span className="update-chip__icon" aria-hidden="true" />
        {TEXT.badge}
      </button>
    );
  }

  return (
    <div className="update-banner" role="status">
      <p className="update-banner__message">{TEXT.available}</p>
      <div className="update-banner__actions">
        <BaseButton title={TEXT.reload} className="base-btn size-small update-banner__reload" onClick={() => window.location.reload()} />
        <button type="button" className="update-banner__collapse" aria-label={TEXT.collapse} onClick={() => setCollapsed(true)} />
      </div>
    </div>
  );
}

export default UpdateBanner;
